var Grid;
(function (Grid) {
    Grid["2px"] = "2px";
    Grid["4px"] = "4px";
    Grid["8px"] = "8px";
    Grid["16px"] = "16px";
    Grid["24px"] = "24px";
    Grid["32px"] = "32px";
    Grid["40px"] = "40px";
    Grid["48px"] = "48px";
    Grid["56px"] = "56px";
    Grid["64px"] = "64px";
    Grid["72px"] = "72px";
    Grid["80px"] = "80px";
    Grid["88px"] = "88px";
    Grid["96px"] = "96px";
    Grid["104px"] = "104px";
    Grid["112px"] = "112px";
    Grid["120px"] = "120px";
    Grid["128px"] = "128px";
})(Grid || (Grid = {}));
export default Grid;
//# sourceMappingURL=Grid.js.map